/**
 * The CMS mark: a page split into content blocks (header, body, two side
 * blocks), the thing the product edits. Same drawing as public/favicon.svg.
 * The gradient id is fixed because the mark can appear twice on one page and
 * both copies reference the same definition.
 */
export function BrandMark({ large = false }: { large?: boolean }) {
  return (
    <svg className={large ? 'brand-mark brand-mark-large' : 'brand-mark'} viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="brand-mark-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffb800" />
          <stop offset="0.5" stopColor="#ff5a00" />
          <stop offset="1" stopColor="#ff1d6c" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="112" fill="url(#brand-mark-gradient)" />
      <rect x="104" y="104" width="304" height="76" rx="22" fill="#fff" />
      <rect x="104" y="204" width="132" height="204" rx="22" fill="#fff" />
      <rect x="260" y="204" width="148" height="88" rx="22" fill="#ffe34d" />
      <rect x="260" y="316" width="148" height="92" rx="22" fill="#fff" fillOpacity="0.6" />
    </svg>
  )
}
